import { btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import PageSection from '~/src/features/domru-tv/packages/components/PageSection';
import TvPackageCard from '~/src/features/domru-tv/packages/components/TvPackageCard';
import { useSectionData } from '~/src/features/domru-tv/packages/hooks/useSectionData';
import { ESectionId, TDetailsType } from '~/src/features/domru-tv/packages/types';
import { ITvPackage } from '~/src/store/reducers/tvPackages';

interface IProps {
    sectionId: ESectionId,
    onShowMore: (type: TDetailsType) => void,
}

const Packs = ({ sectionId, onShowMore }: IProps): JSX.Element => {
    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    const { isShowSectionButton, sectionWidgets } = useSectionData<ITvPackage>('packs', false);

    return (
        <PageSection id={sectionId}>
            <PageSection.Title>Пакеты каналов</PageSection.Title>
            <PageSection.Content>
                {sectionWidgets.map(packet => (
                    <TvPackageCard
                        key={packet.id}
                        tvPacket={packet}
                        data-test='package-card'
                    />
                ))}
            </PageSection.Content>
            {isShowSectionButton && (
                <PageSection.Button
                    type={btnTypes.SECONDARY}
                    size={isMobile ? btnSizes.LARGE : btnSizes.MIDDLE}
                    text={'Смотреть все'}
                    onClick={() => onShowMore('packs')}
                    data-test='details-button'
                />
            )}
        </PageSection>
    );
};

export default Packs;
